import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Breadcrumb, Tag, Input, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, EditOutlined, DeleteOutlined, HomeOutlined, AuditOutlined} from '@ant-design/icons';
import { DELETE_EVENTVERIFIER_LIST, DELETE_EVENTVERIFIER_LIST_ERROR, DELETE_EVENTVERIFIER_LIST_SUCCESS, EDIT_BATCH, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, EVENTVERIFIER_LIST, EVENTVERIFIER_LIST_DETAILS, EVENTVERIFIER_LIST_DETAILS_ERROR, EVENTVERIFIER_LIST_DETAILS_SUCCESS, EVENTVERIFIER_LIST_ERROR, EVENTVERIFIER_LIST_SUCCESS} from './constants';
import axios from 'axios';
import modelReducer from './reducer';
import { useLocation, useNavigate } from 'react-router-dom';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import { useAuth } from '../../Context';


const { Title } = Typography;



export default function EventVerifier() {


	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { retrain_historydata:[], batch : [], verfiedevents : [], details: null, loading: false, error: false, modelDeploymentInfo:[]};
	const [data, dispatch] = useReducer(modelReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	// const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteeventverifierModal, setShowDeleteeventverifierModal] = useState(false);
	useAuth();
	
	
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	
	const location = useLocation();
	const {id} = location.state;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const {getAllEvents,eventsData} = useAuth();
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);


	const columns = [
	
			
	
	
		{
			title: `${langdata && langdata.referenceEventId ? langdata.referenceEventId:'Reference EventId'}`,
			dataIndex: 'referenceEventId',
			key: 'referenceEventId',
				
		},
		{
			title: `${langdata && langdata.eventPosition ? langdata.eventPosition:'Event Position'}`,
			dataIndex: 'eventPosition',
			key: 'eventPosition',
				
		},
		{
			title: `${langdata && langdata.referenceevent ? langdata.referenceevent:'Reference event'}`,
			dataIndex: 'referenceevent',
			key: 'referenceevent',
				
		},
		{
			title: `${langdata && langdata.ConfirmedEvent ? langdata.ConfirmedEvent:'Confirmed Event'}`,
			dataIndex: 'confirmedEvent',
			key: 'confirmedEvent',
			render: (event, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}
			
				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}
			
				if (event == null || event === '' || event === 'No Data') {
					return <Tag color="yellow">No Data</Tag>;
				}
			
				return <Tag color="green">{event}</Tag>;
			}
			
		}
		,
		{
			title: `${langdata && langdata.Confidence ? langdata.Confidence:'Confidence'}`,
			dataIndex: 'confirmedEventConfidence',
			key: 'confirmedEventConfidence',
					
		},
		{
			title: langdata&&langdata.Status?langdata.Status:'Status',
			dataIndex: 'status',
			key: 'status',
			render: (_, { status }) => {
			
				let color = '';
				if(status === 'New') color = 'blue';
				if(status==='Inprogress') color ='yellow';
				if(status ==='Completed') color = 'green';
				if(status=== 'Failed') color = 'red';
							
				return (<>
					<Tag color={color} >
						{status}
					</Tag>
				</>);
			},
							
		},

		{
			title: `${langdata && langdata.verifiedEvent ? langdata.verifiedEvent : 'Verified Event'}`,
			dataIndex: 'verifiedEvent',
			key: 'verifiedEvent',

			render: (_, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}

				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}

				if (record?.status === 'Failed') {
					return <Tag color="red">Failed</Tag>;
				}

				if (record?.status === 'Completed') {
					return record?.verifiedEvent?.length ? (
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
							{record.verifiedEvent.map((item, index) => (
								<Tag color="blue" key={index}>
									{item}
								</Tag>
							))}
						</div>
					) : (
						<Tag color="yellow">No Data</Tag>
					);
				}

				return  <Tag color="red">Failed</Tag>;
			}
		},

		{
			title: `${langdata && langdata.verifiedfibermetric ? langdata.verifiedfibermetric:'Verified Fibermetric'}`,
			dataIndex: 'verifiedEvent',
			key: 'verifiedEvent',
			render: (_, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}

				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}

				if (record?.status === 'Failed') {
					return <Tag color="red">Failed</Tag>;
				}

				if (record?.status === 'Completed') {
					return 		record?.verifiedODmeter?.length ? (
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
							{record.verifiedODmeter.map((item, index) => (
								<Tag color="blue" key={index}>
									{item}
								</Tag>
							))}
						</div>
					) : (
						<Tag color='yellow'>No Data</Tag>
					);
				}

				return  <Tag color="red">Failed</Tag>;
			}

		},

		{
			title: `${langdata && langdata.verifiedIndex ? langdata.verifiedIndex:'Verified Index'}`,
			dataIndex: 'verifiedIndex',
			key: 'verifiedEvent',
			render: (_, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}

				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}

				if (record?.status === 'Failed') {
					return <Tag color="red">Failed</Tag>;
				}

				if (record?.status === 'Completed') {
					return record?.verifiedIndex?.length ? (
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
							{record.verifiedIndex.map((item, index) => (
								<Tag color="blue" key={index}>
									{item}
								</Tag>
							))}
						</div>
					) : (
						<Tag color='yellow'>No Data</Tag>
					);
				}

				return  <Tag color="red">Failed</Tag>;
			}


		},
		{
			title: `${langdata && langdata.verifiedConfidence ? langdata.verifiedConfidence:'Verified Confidence'}`,
			dataIndex: 'verifiedConfidence',
			key: 'verifiedConfidence',
			render: (_, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}

				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}

				if (record?.status === 'Failed') {
					return <Tag color="red">Failed</Tag>;
				}

				if (record?.status === 'Completed') {
					return record?.verifiedConfidence?.length ? (
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
							{record.verifiedConfidence.map((item, index) => (
								<Tag  color="blue" key={index}>
									{item}
								</Tag>
							))}
						</div>
					) : (
						<Tag color='yellow'>No Data</Tag>
					);}

				return  <Tag color="red">Failed</Tag>;
			}
			
		},

		{
			title: `${langdata && langdata.ValidatorEvent ? langdata.ValidatorEvent : 'Validator Event'}`,
			dataIndex: 'validatorEvent',
			key: 'validatorEvent',

			render: (_, record) => {				
				if (record?.validatorProcessed == false) {
					return <Tag color="blue">TBU</Tag>;
				}

				if (!record?.validatorProcessed || !record?.validatorEvent?.length) {
					return <Tag color="yellow">No Data</Tag>;
				}

				return (
					<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
						{record.validatorEvent.map((item, index) => (
							<Tag color="blue" key={index}>
								{item}
							</Tag>
						))}
					</div>
				);
			}
		},
		{
			title: `${langdata && langdata.ValidatorConfidence ? langdata.ValidatorConfidence : 'Validator Confidence'}`,
			dataIndex: 'validatorConfidence',
			key: 'validatorConfidence',

			render: (_, record) => {				
				if (record?.validatorProcessed == false) {
					return <Tag color="blue">TBU</Tag>;
				}

				if (!record?.validatorProcessed || !record?.validatorConfidence?.length) {
					return <Tag color="yellow">No Data</Tag>;
				}

				return (
					<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
						{record.validatorConfidence.map((item, index) => (
							<Tag color="blue" key={index}>
								{item}
							</Tag>
						))}
					</div>
				);
			}
		},
		
		
	];

	if(permission==='superadmin' || permission === 'admin'){

		columns.push(

			{
				title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
				key: 'attachmentUrls',
				align:'center',
				render: (_,record) => (
							
			
					<>
						<Space style={{justifyContent:'center',display:'flex'}} size="middle">
							<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  disabled={record.status != 'New'} onClick={record.status === 'New' ?()=> showEditDrawer(record) : null}><EditOutlined/></a>
							<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'}  disabled={record.status != 'New'} onClick={record.status === 'New' ? ()=>openDeleteeventverifierModal(record) : null}><DeleteOutlined /></a>
			
						</Space>
					</>
				)
			}

		);
	}

	
	useEffect(() => {
		if(featuresModule.eventverifierEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4032);

	}, []);
	
	useEffect(() => {
		loadeventverifierlist();
		getAllEvents(authtoken);
	}, []);


	const loadeventverifierlist = () => {


		dispatch({ type : EVENTVERIFIER_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/eventverifier?eventverifierbatchId=${id}&pipelineId=${pipelineId}&$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
	
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : EVENTVERIFIER_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : EVENTVERIFIER_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : EVENTVERIFIER_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.eventveriferinfocontent ? langdata.eventveriferinfocontent :'This module displays each batch of event data in a list format, organized based on the index or fiber optic length.'}</p>
		</Card>
	);

	const showEditDrawer = (record) => {
		setOpenEditDrawer(true);
		loadeventDetails(record);
		
	};

	const openDeleteeventverifierModal = (record) => {
		setShowDeleteeventverifierModal(true);
		loadeventDetails(record);
	};


	const editeventverifierformik = useFormik({
		enableReinitialize: true,
		initialValues: {
			eventPosition:  data?.details?.eventPosition ? data?.details?.eventPosition : null ,
			referenceevent: data?.details?.referenceevent ? data?.details?.referenceevent : '' ,
			referenceEventId: data?.details?.referenceEventId ? data?.details?.referenceEventId : null ,
			
		},
		onSubmit: (values) => {


			if (!values.eventPosition || values.eventPosition === null) { 
				Modal.warning({
					title: langdata && langdata.pleaseentereventposition ?  langdata.pleaseentereventposition : 'Please enter event position'
				});
				return;
			}
			
			if (!values.referenceevent || values.referenceevent === '') {
				Modal.warning({
					title: langdata && langdata.pleaseSelectreferenceevent ?  langdata.pleaseSelectreferenceevent : 'Please select reference event'
				});
				return;
			}
	
		
			dispatch({type:EDIT_BATCH});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/eventverifier/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					eventPosition : Number(values.eventPosition),
					referenceevent: values.referenceevent,
					referenceEventId: Number(values.referenceEventId)
					
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_BATCH_SUCCESS});
						Modal.success({ title: `${langdata && langdata.EventverifiersUpdatedSUccessfully ? langdata.EventverifiersUpdatedSUccessfully :'Event verifiers Updated SUccessfully'}` });
						editeventverifierformik.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadeventverifierlist();
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadeventDetails = ((record) => {
		
		dispatch( { type: EVENTVERIFIER_LIST_DETAILS });
			
		if (!record) {
			dispatch({ type: EVENTVERIFIER_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: EVENTVERIFIER_LIST_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		setOpenEditDrawer(false);
		editeventverifierformik.resetForm();
		form.resetFields();

	};
	const closeDeleteQuestionModal = () => {
		setShowDeleteeventverifierModal(false);
	};

	const deleteQuestion = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_EVENTVERIFIER_LIST });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/eventverifier/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_EVENTVERIFIER_LIST_SUCCESS});
					setShowDeleteeventverifierModal(false);        
					loadeventverifierlist();
				} else {
					dispatch({type:DELETE_EVENTVERIFIER_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_EVENTVERIFIER_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	let referenceeventoptions=[];
    
	eventsData && eventsData.map((item) => {
		referenceeventoptions.push({
			value : item.id,
			label: item.eventType
		});
	});

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleeventposition =(e)=>{
		editeventverifierformik.setFieldValue('eventPosition',e.target.value);

	};


	const handlereferenceevent =(value,options)=>{
		const referenceevent = options?.label;
		editeventverifierformik.setFieldValue('referenceevent',referenceevent);
	};

	const handlereferenceEventId =(e)=>{
		editeventverifierformik.setFieldValue('referenceEventId',e.target.value);

	};
	


	return (
		<>
			<Content>
				
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
					

					<Col span={8}>
						<Row>

							<Space>
								<AuditOutlined style={{fontSize:'30px'}} />

							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.eventverifier ? langdata.eventverifier:'Event Verifier'}</Title>
						</Row>

					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								{/* <Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		 */}
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.eventverifier ? langdata.eventverifier:'Event Verifier'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row 
					style={{
						marginLeft:'15px',
						marginTop: '10px',
						marginBottom: '10px',
					}}            
				>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title:  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.EventVerifierBatch ? langdata.EventVerifierBatch :'Event Verifier Batch'}</a> 
							},
							{
								title: `${langdata && langdata.eventverifier ? langdata.eventverifier :'Event Verifier'}`,
							},
						]}
					/>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.verfiedevents?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.verfiedevents} 
								onChange = { loadeventverifierlist }
								
							/>
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				{/* <Modal
					title={ langdata&&langdata.AddQuestion ? langdata.AddQuestion : 'Add Question' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addQuestion.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addQuestion.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Questions?langdata.Questions:'Questions'} rules={[{ required: true, message: langdata && langdata.PleaseEnterTheQuestion ? langdata.PleaseEnterTheQuestion : 'Please enter the question' }]} >
									<TextArea   autoSize={{ minRows: 1}} name="name" onChange={addQuestion.handleChange} placeholder={langdata&&langdata.PleaseEnterTheQuestion?langdata.PleaseEnterTheQuestion:'Please enter the question'} />
								</Form.Item>
							</Col>
						</Row>														
					</Form>
				</Modal> */}


				<Modal
					title={langdata && langdata.Editeventverifier ? langdata.Editeventverifier:'Edit Event Verifier'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editeventverifierformik.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editeventverifierformik.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editeventverifierformik.handleSubmit} layout="vertical"
						form={form} 
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="eventPosition" label={langdata&&langdata.eventPosition?langdata.eventPosition:'Event Position'} rules={[{ required: true, message: langdata && langdata.pleaseentereventPosition ? langdata.pleaseentereventPosition : 'please enter event position' }]} >
									<Input name="eventPosition" onChange={(e)=>handleeventposition(e)} 
										placeholder={langdata && langdata.pleaseentereventPosition ? langdata.pleaseentereventPosition : 'please enter event position'} 
										defaultValue={editeventverifierformik.values.eventPosition}/>
										
								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="referenceevent" label={ langdata&&langdata.referenceevent?langdata.referenceevent:'Reference event'} rules={[{ required: true, message: langdata && langdata.pleaseselectreferenceevent ? langdata.pleaseselectreferenceevent :'please select reference event'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="referenceevent"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.pleaseselectreferenceevent ? langdata.pleaseselectreferenceevent :'please select reference event'}
										optionFilterProp="children"	
										onChange={(value,label)=>{handlereferenceevent(value,label);}}
										defaultValue={editeventverifierformik.values.referenceevent}
										// onSelect={handleSetChannel}
										options={referenceeventoptions}
															
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="referenceEventId" label={langdata&&langdata.referenceEventId?langdata.referenceEventId:'Reference Event Id'} rules={[{ required: true, message: langdata && langdata.pleaseenterreferenceeventId ? langdata.pleaseenterreferenceeventId : 'Please enter reference eventId' }]} >
									<Input name="referenceEventId" onChange={(e)=>handlereferenceEventId(e)} 
										defaultValue={editeventverifierformik.values.referenceEventId}
										placeholder={langdata && langdata && langdata.pleaseenterreferenceeventId ? langdata.pleaseenterreferenceeventId : 'Please enter reference eventId' } />
								</Form.Item>
							</Col>
						</Row>
						
				
									
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteeventverifierModal} onOk={deleteQuestion} onCancel={closeDeleteQuestionModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThiseventverifier ? langdata.AreYouSureYouWantToDeleteThiseventverifier : 'Are You Sure You Want To Delete This event verifier' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}